import 'flatpickr/dist/themes/material_blue.css'

import { Controller, useForm } from 'react-hook-form'
import {
	FormSectionCard,
	GradientText,
	SubmitButton,
	SubmitButtonContainer,
	Wrapper,
} from '../PasserCommande/PasserCommande.styles'
import React, { useEffect, useState } from 'react'
import {
	getSingleChauffeur,

} from '../../api/clients'
import { updateChauffeur } from '../../api/chauffeurs'
import { useDispatch, useSelector } from 'react-redux'

import { CustomInput } from '../RegisterTransporter/style'
import Flatpickr from 'react-flatpickr'
import { French } from 'flatpickr/dist/l10n/fr.js'
import LayoutChauffeur from '../../Components/LayoutChauffeur/LayoutChauffeur'
import toast from 'react-hot-toast'
import { updateProfile } from '../../redux/auth'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { validatePhoneNumber } from '../../utils/phoneValidator'
import { useTranslation } from 'react-i18next'


function ChauffeurAccount() {
	const { _id } = useSelector((state) => state.auth.user)
	const token = useSelector((state) => state.auth.token);
    const {t} = useTranslation();
	const dispatch = useDispatch()

	const {
		register,
		handleSubmit,
		reset,
		control,
		formState: { errors },
	} = useForm()

	const [chauffeur, setChauffeur] = useState()
	const [loading, setLoading] = useState(false)
	const [chargementEnCours, setChargementEnCours] = useState(false);

	async function fetchChauffeur(_id) {
		setChargementEnCours(true)
		try {
			const data = await getSingleChauffeur(_id, token)
			setChauffeur(data)
			reset({
				address: data?.address,
				city: data?.city,
				postalCode: data?.postalCode,
				phone: data?.phone
			})
		} catch (error) {
			toast.error(t("transfer_request_err"), {
				style: {
					fontFamily: 'Montserrat',
				},
			});
		} finally {
			setChargementEnCours(false)

		}

	}
	useEffect(() => {
		if (_id) {
			fetchChauffeur(_id)
		}
	}, [_id])


	const onSubmit = async (data) => {
		setLoading(true)
		const update = {
			address: data.address,
			city: data.city,
			postalCode: data.postalCode,
			phone: data.phone,
		}

		try {
			const res = await updateChauffeur(_id, update, token)
			toast.success(t("account_updated"), {
				style: {
					fontFamily: 'Montserrat',
				},
			})
			dispatch(updateProfile(res))

		} catch (error) {
			toast.error(t("transfer_request_err"), {
				style: {
					fontFamily: 'Montserrat',
				},
			})
		} finally {
			setLoading(false)

		}

	}
	const renderLicenseType = (type) =>{
		switch (type) {
			case 'Léger' : return t("light")
			case 'Lourds' : return t("heavy")
			case 'Super lourds' : return t("extra_heavy")
			default : return type
			
		}
	}
	const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth <= 768);


	useEffect(() => {
		const checkIfMobile = () => {
			setSmallScreen(window.innerWidth <= 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);



	return (
		<LayoutChauffeur>
			<div
				style={{
					width: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					paddingTop: '2rem',
					paddingBottom: '4rem',
					paddingLeft: '1.5rem',
					paddingRight: '1.5rem',
				}}
			>
				<Wrapper>
					<GradientText style={{
						fontSize: isSmallScreen ? '2rem' : '2.5rem'
					}}>{t("my_account").toUpperCase()}</GradientText>
				</Wrapper>
				{chargementEnCours ?
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							backgroundColor: 'white',
							position: 'absolute',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,

						}}
					>
						<div className='customLoader'></div>
					</div>
					:
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							width: '100%',
						}}
					>
						<div
							style={{
								width: '100%',
								fontFamily: 'Montserrat',
								alignSelf: 'center',
							}}
						>
							<form onSubmit={handleSubmit(onSubmit)}>
								<FormSectionCard>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											marginBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												marginBottom: '1rem',
											}}
										>
											{t("gender")}
										</span>
										<div
											style={{
												display: 'flex',
												flexDirection: isSmallScreen ? 'column' : 'row',
												gap: isSmallScreen ? '0.5rem' : 0
											}}
										>
											<div
												style={{
													width: isSmallScreen ? '100%' : '30%',
												}}
											>
												<input
													type='radio'
													disabled
													style={{
														marginRight: '1rem',
														transform: 'scale(1.5)',
													}}
													checked={chauffeur?.sexe === 'homme'}
													value={'homme'}
												/>

												<span>{t("male")}</span>
											</div>

											<div>
												<input
													type='radio'
													disabled
													style={{
														marginRight: '1rem',
														transform: 'scale(1.5)',
													}}
													checked={chauffeur?.sexe === 'femme'}
													value={'femme'}
												/>

												<span>{t("female")}</span>
											</div>
										</div>
									</div>

									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											marginBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												marginBottom: '1rem',
											}}
										>
											{t("license")}
										</span>
										<div
											style={{
												display: 'flex',
												flexDirection: isSmallScreen ? 'column' : 'row',
												gap: isSmallScreen ? '0.5rem' : 0
											}}
										>
											{[
												'Léger',
												'Lourds',
												'Super lourds',
											].map((item, index) => (
												<div
													key={String(index)}
													style={{
														width: isSmallScreen ? '100%' : '30%',
													}}
												>
													<input
														type='checkbox'
														disabled
														style={{
															marginRight: '1rem',
															transform: 'scale(1.5)',
														}}
														checked={chauffeur?.permis?.includes(item)}
														value={item}
													/>

													<span>{renderLicenseType(item)}</span>
												</div>
											))}
										</div>
									</div>


									<div
										style={{
											display: 'flex',
											flexDirection: isSmallScreen ? 'column' : 'row',
											gap: isSmallScreen ? '1rem' : 0,
											marginBottom: '2rem',
										}}
									>
										<div
											style={{
												width: isSmallScreen ? '100%' : '50%',
												display: 'flex',
												flexDirection: 'column',
											}}
										>
											<span
												style={{
													color: '#262626',
													paddingBottom: '1rem',
												}}
											>
												{t("last_name")}
											</span>
											<CustomInput
												type='text'
												disabled
												value={chauffeur?.last_name}
												style={{
													backgroundColor: '#f0f0f0',
													color: '#a9a9a9',
													cursor: 'not-allowed'
												}}
											/>
										</div>

										<div style={{ width: 50 }} />

										<div
											style={{
												width: isSmallScreen ? '100%' : '50%',
												display: 'flex',
												flexDirection: 'column',
											}}
										>
											<span
												style={{
													color: '#262626',
													paddingBottom: '1rem',
												}}
											>
												{t("first_name")}
											</span>
											<CustomInput
												type='text'
												disabled
												value={chauffeur?.first_name}
												style={{
													backgroundColor: '#f0f0f0',
													color: '#a9a9a9',
													cursor: 'not-allowed'
												}}
											/>
										</div>
									</div>

									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											marginBottom: '2rem',
										}}
									>
										<div
											style={{
												width: '100%',
												display: 'flex',
												flexDirection: 'column',
											}}
										>
											<span
												style={{
													color: '#262626',
													paddingBottom: '1rem',
												}}
											>
												{t("address")}
											</span>
											<Controller
												name="address"
												control={control}
												defaultValue={chauffeur?.address}
												rules={{
													required: t("enter_address"),
													minLength: {
														value: 3,
														message: t("article_elided") +t("address") +t("err_message2"),
													},
													pattern: {
														value: /^[A-Za-zÀ-ÿ0-9\s',.\-/()°]+$/,
														message: t("article_elided") +t("address") +t("err_message3"),

													},
												}}
												render={({ field }) => (
													<CustomInput
														type='text'
														placeholder='54 rue avenue de la grande armée, 75017, Paris, France'
														{...field}
													/>
												)}
											/>
											{errors.address && (
												<div style={{ color: 'red', marginTop: '0.5rem', fontSize: "14px" }}>
													{errors.address.message}
												</div>
											)}
										</div>
									</div>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											{t("city")}
										</span>
										<CustomInput
											type='text'

											{...register('city', {
												required: t("enter_city"),
												minLength: {
													value: 3,
													message: t("article_f") +t("city") +t("err_message2"),
												},
												pattern: {
													value: /^.+$/,
													message: t("article_f") +t("city") +t("err_message3"),
												},
											})}
										/>
										{errors.city && (
											<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
												{errors.city.message}
											</div>
										)}
									</div>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											{t("zip_code")}
										</span>
										<CustomInput
											type='text'

											{...register('postalCode', {
												required: t("enter_postal_code"),
												pattern: {
													value: /^\d{5}$/,
													message: t("zip_code_err_message"),
												},
											})}
										/>
										{errors.postalCode && (
											<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
												{errors.postalCode.message}
											</div>
										)}
									</div>
									<div
										style={{
											display: 'flex',
											flexDirection: isSmallScreen ? 'column' : 'row',
											gap: isSmallScreen ? '1rem' : 0,
											marginBottom: '2rem',
										}}
									>
										<div
											style={{
												width: isSmallScreen ? '100%' : '50%',
												display: 'flex',
												flexDirection: 'column',
											}}
										>
											<span
												style={{
													color: '#262626',
													paddingBottom: '1rem',
												}}
											>
												{t("contact_us_formulair_item2")}
											</span>
											<Controller
												name="phone"
												control={control}
												defaultValue={chauffeur?.phone}
												rules={{
													validate: validatePhoneNumber
												}}
												render={({ field }) => (
													<PhoneInput
														country={'fr'}
														value={field.value}
														onChange={(phone, countryData) => {
															field.onChange(phone);
														}}
														inputProps={{
															name: field.name,
															required: true,
														}}
														inputStyle={{
															paddingRight: '1.5rem',
															paddingTop: '1.5rem',
															paddingBottom: '1.5rem',
															borderRadius: '0.5rem',
															border: 'none',
															fontFamily: 'Montserrat',
															color: '#858ea8',
															flex: '1',
															display: 'flex',
															width: '100%',
														}}
														buttonStyle={{
															borderRadius: '0.5rem',
															border: 'none',
															fontFamily: 'Montserrat',
															color: '#858ea8',
															flex: '1',
															display: 'flex',
														}}

														containerStyle={{
															width: '100%',
														}}
														placeholder="(0) 01 45 66 32 88"
														enableSearch={true}
														searchPlaceholder="Rechercher un pays"
													/>
												)}
											/>

										</div>

										<div style={{ width: 50 }} />

										<div
											style={{
												width: isSmallScreen ? '100%' : '50%',
												display: 'flex',
												flexDirection: 'column',
											}}
										>
											<span
												style={{
													color: '#262626',
													paddingBottom: '1rem',
												}}
											>
												{t("email")}
											</span>
											<CustomInput
												type='text'
												disabled
												value={chauffeur?.email}
												style={{
													backgroundColor: '#f0f0f0',
													color: '#a9a9a9',
													cursor: 'not-allowed'
												}}

											/>
										</div>
									</div>

									<div
										style={{
											display: 'flex',
											flexDirection: isSmallScreen ? 'column' : 'row',
											gap: isSmallScreen ? '1rem' : 0,
											marginBottom: '2rem',
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												width: isSmallScreen ? '100%' : '50%',
											}}
										>
											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
												}}
											>
												{t("date_of_birth")}
											</span>
											<Flatpickr
												disabled
												className="date-input"
												options={{
													mode: 'single',
													locale: French,
													dateFormat: 'd/m/Y',
												}}
												value={chauffeur?.date_naiss}
											/>

										</div>

										<div style={{ width: 50 }} />

										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												width: isSmallScreen ? '100%' : '50%',
											}}
										>
											<span
												style={{
													marginBottom: '1rem',
													color: 'black',
													fontSize: 14,
												}}
											>
												{t("hire_date")}
											</span>
											<Flatpickr
												disabled
												className="date-input"
												options={{
													mode: 'single',
													locale: French,
													dateFormat: 'd/m/Y',
												}}
												value={chauffeur?.date_embauche}
											/>

										</div>
									</div>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											marginBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												marginBottom: '1rem',
											}}
										>
											Fimo
										</span>
										<div
											style={{
												display: 'flex',
												flexDirection: isSmallScreen ? 'column' : 'row',
												gap: isSmallScreen ? '0.5rem' : 0
											}}
										>
											{[
												{ label: t("yes"), value: true },
												{ label: t("no"), value: false },
											].map(({ label, value }, index) => (
												<div
													key={String(index)}
													style={{
														width: isSmallScreen ? '100%' : '25%',
													}}
												>
													<input
														type="radio"
														style={{
															marginRight: '1rem',
															transform: 'scale(1.5)',
														}}
														disabled
														value={value}
														checked={value === chauffeur?.fimo}
													/>

													<span>{label}</span>
												</div>
											))}
										</div>

									</div>


									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											marginBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												marginBottom: '1rem',
											}}
										>
											{t("hazardous_materials")}
										</span>
										<div
											style={{
												display: 'flex',
												flexDirection: isSmallScreen ? 'column' : 'row',
												gap: isSmallScreen ? '0.5rem' : 0
											}}
										>
											{[
												{ label: t("yes"), value: true },
												{ label: t("no"), value: false },
											].map(({ label, value }, index) => (
												<div
													key={String(index)}
													style={{
														width: isSmallScreen ? '100%' : '25%',
													}}
												>
													<input
														type="radio"
														style={{
															marginRight: '1rem',
															transform: 'scale(1.5)',
														}}
														disabled
														checked={value === chauffeur?.danger}
														value={value}
													/>

													<span>{label}</span>
												</div>
											))}
										</div>

									</div>

								</FormSectionCard>

								<div style={{ height: '1rem' }} />

								<SubmitButtonContainer>
									<SubmitButton type='submit' disabled={loading}>
										{loading ? (
											<div className='loader'></div>
										) : (
											t("save")
										)}
									</SubmitButton>
								</SubmitButtonContainer>
							</form>
						</div>
					</div>
				}
			</div>
		</LayoutChauffeur>
	)
}

export default ChauffeurAccount
